/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ContentPosition,
  CreateSpace,
  DefaultLevel,
  Emoji,
  EntityId,
  List,
  MergeRulesSpaceConfiguration,
  Space,
  SpaceEditMode,
  SpaceTitle,
  TranslationLanguage,
  URL,
} from "./data-contracts";

/**
 * @description Returns the full metadata for a space. Use this to resolve a spaceId into a complete Space object. If you only need content, use the content endpoint instead.
 * @tags spaces, critical
 * @name GetSpaceById
 * @summary Get full details of a space by its ID
 * @request GET:/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const getSpaceById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}",
  method: "get",
  streaming: false,
  tags: ["spaces", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Updates a space's metadata and settings. To update page content, use the change-request workflow instead.
 * @tags spaces
 * @name UpdateSpaceById
 * @summary Update a space's title, icon, or settings
 * @request PATCH:/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const updateSpaceById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * Determines how a Space can be edited.
     * * `live`: Users can directly edit the space
     * * `locked`: All edits are locked for this space.
     */
    editMode?: SpaceEditMode;
    /** Title of the space */
    title?: SpaceTitle;
    /** Default level for a piece of content */
    defaultLevel?: DefaultLevel;
    language?: TranslationLanguage;
    mergeRules?: MergeRulesSpaceConfiguration;
  } & (
    | {
        /** Unicode codepoint or character of the emoji */
        emoji: Emoji;
      }
    | {
        icon: URL;
      }
    | {
        emoji?: null;
        icon?: null;
      }
  );
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}",
  method: "patch",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Deleted spaces will be permanently removed after 7 days.
 * @tags spaces
 * @name DeleteSpaceById
 * @summary Delete a space
 * @request DELETE:/spaces/{spaceId}
 * @secure
 */

// @ts-ignore
export const deleteSpaceById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}",
  method: "delete",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a new space that is a complete copy of the specified space, including all pages and their content. The duplicate is created in the same organization. It does not preserve or create a placement in a site. When duplicating from a site context, use duplicateSiteSpace instead. Use this operation for an organization-level or orphan-space copy.
 * @tags spaces
 * @name DuplicateSpace
 * @summary Create a full copy of a space
 * @request POST:/spaces/{spaceId}/duplicate
 * @secure
 */

// @ts-ignore
export const duplicateSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/duplicate",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Restores a previously deleted space, making it active again. Only spaces deleted within the last 7 days can be restored; after that they are permanently removed. Returns the restored space object. To delete a space, use the space delete endpoint.
 * @tags spaces
 * @name RestoreSpace
 * @summary Restore a recently deleted space from the trash
 * @request POST:/spaces/{spaceId}/restore
 * @secure
 */

// @ts-ignore
export const restoreSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/restore",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Moves a space to a new parent collection and/or a new position within the hierarchy.
 * @tags spaces
 * @name MoveSpace
 * @summary Move a space to a different collection or position
 * @request POST:/spaces/{spaceId}/move
 * @secure
 */

// @ts-ignore
export const moveSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** The unique id of the parent collection */
    parent?: string | null;
    /** Where to move the space. By default, it will be moved at the end. */
    position?: ContentPosition;
  };
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200 | 400 | 404 | 409;
} = {
  route: "/spaces/{spaceId}/move",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of all spaces belonging to the organization. A space is a collection of documentation pages with its own content tree and revision history. Use this to discover spaces before reading their content, adding them to a site, or performing operations on specific spaces.
 * @tags spaces
 * @name ListSpacesInOrganizationById
 * @summary List all spaces in an organization
 * @request GET:/orgs/{organizationId}/spaces
 * @secure
 */

// @ts-ignore
export const listSpacesInOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Space[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/spaces",
  method: "get",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a new space within the organization. A space is the primary container for documentation content, holding pages, files, and revisions. After creation, add the space to a site to make it publicly accessible, or start adding content directly via the space content endpoints.
 * @tags spaces
 * @name CreateSpace
 * @summary Create a new documentation space in an organization
 * @request POST:/orgs/{organizationId}/spaces
 * @secure
 */

// @ts-ignore
export const createSpace: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: CreateSpace | undefined;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/spaces",
  method: "post",
  streaming: false,
  tags: ["spaces"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
